//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const SERVICES_PAYMENTS_API_BASE_URL = new InjectionToken<string>('SERVICES_PAYMENTS_API_BASE_URL');

export interface IServicesPaymentsApiService {
    /**
     * Adds an order and order items
     * @return Created
     */
    createMyOrder(body: InsertOrderRequest): Observable<OrderResponse>;
    /**
     * Get all my orders
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param number (optional) 
     * @param status (optional) 
     * @param completedDate (optional) 
     * @param invoiceType (optional) 
     * @param wayOfPayment (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    getOrderList(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, number?: string | undefined, status?: OrderStatus[] | undefined, completedDate?: Date | undefined, invoiceType?: ProofOfPayment[] | undefined, wayOfPayment?: WayOfPayment[] | undefined, accountId?: string | undefined): Observable<OrderResponseResultSet>;
    /**
     * Gets order by number
     * @return OK
     */
    getOrderByNumber(orderNumber: string): Observable<OrderResponse>;
    /**
     * Updates my order
     * @return Created
     */
    updateMyOrder(orderNumber: string, body: UpdateOrderRequest): Observable<OrderResponse>;
    /**
     * Creates SessionId, updates it in Order and create a TransactionId
     * @return Created
     */
    createGatewaySession(orderNumber: string, body: CreateSessionRequest): Observable<CreateSessionResponse>;
    /**
     * Completes order payment and updates transaction
     * @return OK
     */
    gatewayPay(orderNumber: string, transactionId: string): Observable<CompleteSessionResponse>;
    /**
     * Completes order with zero amount. Does not involve transaction
     * @return OK
     */
    settlePay(orderNumber: string): Observable<CompleteSessionResponse>;
    /**
     * Gets service orders statuses
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyServiceOrdersStatuses(propertyId: string, skus: string[], page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<ServiceOrderListResponse>;
    /**
     * Get all orders with filtering
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param number (optional) 
     * @param status (optional) 
     * @param completedDate (optional) 
     * @param invoiceType (optional) 
     * @param wayOfPayment (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    getAllOrdersList(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, number?: string | undefined, status?: OrderStatus[] | undefined, completedDate?: Date | undefined, invoiceType?: ProofOfPayment[] | undefined, wayOfPayment?: WayOfPayment[] | undefined, accountId?: string | undefined): Observable<OrderResponseResultSet>;
    /**
     * Gets order by number
     * @return OK
     */
    getSingeOrderByNumber(orderNumber: string): Observable<OrderResponse>;
    /**
     * Get Order Status for a CaseId
     * @return OK
     */
    getStatusByCaseId(caseId: string): Observable<OrderStatusResponse>;
    /**
     * Get 3ds Payment gateway result and completes payment
     * @param orderRequest (optional) 
     * @return OK
     */
    validateAndProcessPayment(orderRequest?: NbgPaymentGatewayRequest | undefined): Observable<void>;
    /**
     * Returns the products
     * @return OK
     */
    getUnicoProducts(): Observable<ProductResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ServicesPaymentsApiService implements IServicesPaymentsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(SERVICES_PAYMENTS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds an order and order items
     * @return Created
     */
    createMyOrder(body: InsertOrderRequest): Observable<OrderResponse> {
        let url_ = this.baseUrl + "/my/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMyOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMyOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponse>;
        }));
    }

    protected processCreateMyOrder(response: HttpResponseBase): Observable<OrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrderResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all my orders
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param number (optional) 
     * @param status (optional) 
     * @param completedDate (optional) 
     * @param invoiceType (optional) 
     * @param wayOfPayment (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    getOrderList(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, number?: string | undefined, status?: OrderStatus[] | undefined, completedDate?: Date | undefined, invoiceType?: ProofOfPayment[] | undefined, wayOfPayment?: WayOfPayment[] | undefined, accountId?: string | undefined): Observable<OrderResponseResultSet> {
        let url_ = this.baseUrl + "/my/orders?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (completedDate === null)
            throw new Error("The parameter 'completedDate' cannot be null.");
        else if (completedDate !== undefined)
            url_ += "CompletedDate=" + encodeURIComponent(completedDate ? "" + completedDate.toISOString() : "") + "&";
        if (invoiceType === null)
            throw new Error("The parameter 'invoiceType' cannot be null.");
        else if (invoiceType !== undefined)
            invoiceType && invoiceType.forEach(item => { url_ += "InvoiceType=" + encodeURIComponent("" + item) + "&"; });
        if (wayOfPayment === null)
            throw new Error("The parameter 'wayOfPayment' cannot be null.");
        else if (wayOfPayment !== undefined)
            wayOfPayment && wayOfPayment.forEach(item => { url_ += "WayOfPayment=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponseResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponseResultSet>;
        }));
    }

    protected processGetOrderList(response: HttpResponseBase): Observable<OrderResponseResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderResponseResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets order by number
     * @return OK
     */
    getOrderByNumber(orderNumber: string): Observable<OrderResponse> {
        let url_ = this.baseUrl + "/my/orders/{orderNumber}";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponse>;
        }));
    }

    protected processGetOrderByNumber(response: HttpResponseBase): Observable<OrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates my order
     * @return Created
     */
    updateMyOrder(orderNumber: string, body: UpdateOrderRequest): Observable<OrderResponse> {
        let url_ = this.baseUrl + "/my/orders/{orderNumber}";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponse>;
        }));
    }

    protected processUpdateMyOrder(response: HttpResponseBase): Observable<OrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OrderResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates SessionId, updates it in Order and create a TransactionId
     * @return Created
     */
    createGatewaySession(orderNumber: string, body: CreateSessionRequest): Observable<CreateSessionResponse> {
        let url_ = this.baseUrl + "/my/orders/{orderNumber}/checkout";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGatewaySession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGatewaySession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSessionResponse>;
        }));
    }

    protected processCreateGatewaySession(response: HttpResponseBase): Observable<CreateSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CreateSessionResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Completes order payment and updates transaction
     * @return OK
     */
    gatewayPay(orderNumber: string, transactionId: string): Observable<CompleteSessionResponse> {
        let url_ = this.baseUrl + "/my/orders/{orderNumber}/checkout/{transactionId}";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        if (transactionId === undefined || transactionId === null)
            throw new Error("The parameter 'transactionId' must be defined.");
        url_ = url_.replace("{transactionId}", encodeURIComponent("" + transactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGatewayPay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGatewayPay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteSessionResponse>;
        }));
    }

    protected processGatewayPay(response: HttpResponseBase): Observable<CompleteSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Completes order with zero amount. Does not involve transaction
     * @return OK
     */
    settlePay(orderNumber: string): Observable<CompleteSessionResponse> {
        let url_ = this.baseUrl + "/my/orders/{orderNumber}/checkout/settle";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSettlePay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSettlePay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteSessionResponse>;
        }));
    }

    protected processSettlePay(response: HttpResponseBase): Observable<CompleteSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets service orders statuses
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @return OK
     */
    getMyServiceOrdersStatuses(propertyId: string, skus: string[], page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined): Observable<ServiceOrderListResponse> {
        let url_ = this.baseUrl + "/my/orders/{propertyId}/services?";
        if (propertyId === undefined || propertyId === null)
            throw new Error("The parameter 'propertyId' must be defined.");
        url_ = url_.replace("{propertyId}", encodeURIComponent("" + propertyId));
        if (skus === undefined || skus === null)
            throw new Error("The parameter 'skus' must be defined and cannot be null.");
        else
            skus && skus.forEach(item => { url_ += "Skus=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyServiceOrdersStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyServiceOrdersStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOrderListResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOrderListResponse>;
        }));
    }

    protected processGetMyServiceOrdersStatuses(response: HttpResponseBase): Observable<ServiceOrderListResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOrderListResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all orders with filtering
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     * @param search (optional) 
     * @param number (optional) 
     * @param status (optional) 
     * @param completedDate (optional) 
     * @param invoiceType (optional) 
     * @param wayOfPayment (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    getAllOrdersList(page?: number | undefined, size?: number | undefined, sort?: string | undefined, search?: string | undefined, number?: string | undefined, status?: OrderStatus[] | undefined, completedDate?: Date | undefined, invoiceType?: ProofOfPayment[] | undefined, wayOfPayment?: WayOfPayment[] | undefined, accountId?: string | undefined): Observable<OrderResponseResultSet> {
        let url_ = this.baseUrl + "/orders?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (completedDate === null)
            throw new Error("The parameter 'completedDate' cannot be null.");
        else if (completedDate !== undefined)
            url_ += "CompletedDate=" + encodeURIComponent(completedDate ? "" + completedDate.toISOString() : "") + "&";
        if (invoiceType === null)
            throw new Error("The parameter 'invoiceType' cannot be null.");
        else if (invoiceType !== undefined)
            invoiceType && invoiceType.forEach(item => { url_ += "InvoiceType=" + encodeURIComponent("" + item) + "&"; });
        if (wayOfPayment === null)
            throw new Error("The parameter 'wayOfPayment' cannot be null.");
        else if (wayOfPayment !== undefined)
            wayOfPayment && wayOfPayment.forEach(item => { url_ += "WayOfPayment=" + encodeURIComponent("" + item) + "&"; });
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrdersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrdersList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponseResultSet>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponseResultSet>;
        }));
    }

    protected processGetAllOrdersList(response: HttpResponseBase): Observable<OrderResponseResultSet> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderResponseResultSet.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets order by number
     * @return OK
     */
    getSingeOrderByNumber(orderNumber: string): Observable<OrderResponse> {
        let url_ = this.baseUrl + "/orders/{orderNumber}";
        if (orderNumber === undefined || orderNumber === null)
            throw new Error("The parameter 'orderNumber' must be defined.");
        url_ = url_.replace("{orderNumber}", encodeURIComponent("" + orderNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSingeOrderByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSingeOrderByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderResponse>;
        }));
    }

    protected processGetSingeOrderByNumber(response: HttpResponseBase): Observable<OrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Order Status for a CaseId
     * @return OK
     */
    getStatusByCaseId(caseId: string): Observable<OrderStatusResponse> {
        let url_ = this.baseUrl + "/orders/status-by-caseid/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusByCaseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusByCaseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderStatusResponse>;
        }));
    }

    protected processGetStatusByCaseId(response: HttpResponseBase): Observable<OrderStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get 3ds Payment gateway result and completes payment
     * @param orderRequest (optional) 
     * @return OK
     */
    validateAndProcessPayment(orderRequest?: NbgPaymentGatewayRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/payment/result";
        url_ = url_.replace(/[?&]$/, "");

        let content_ = "";
        if (orderRequest === null)
            throw new Error("The parameter 'orderRequest' cannot be null.");
        else if (orderRequest !== undefined)
            content_ += encodeURIComponent("orderRequest") + "=" + encodeURIComponent("" + orderRequest) + "&";
        content_ = content_.replace(/&$/, "");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateAndProcessPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateAndProcessPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateAndProcessPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the products
     * @return OK
     */
    getUnicoProducts(): Observable<ProductResponse[]> {
        let url_ = this.baseUrl + "/productBundles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnicoProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnicoProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductResponse[]>;
        }));
    }

    protected processGetUnicoProducts(response: HttpResponseBase): Observable<ProductResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Address implements IAddress {
    fullName?: string | undefined;
    representativeName?: string | undefined;
    email?: string | undefined;
    phoneNumber1?: string | undefined;
    phoneNumber2?: string | undefined;
    taxNumber?: string | undefined;
    country?: string | undefined;
    prefecture?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.representativeName = _data["representativeName"];
            this.email = _data["email"];
            this.phoneNumber1 = _data["phoneNumber1"];
            this.phoneNumber2 = _data["phoneNumber2"];
            this.taxNumber = _data["taxNumber"];
            this.country = _data["country"];
            this.prefecture = _data["prefecture"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["representativeName"] = this.representativeName;
        data["email"] = this.email;
        data["phoneNumber1"] = this.phoneNumber1;
        data["phoneNumber2"] = this.phoneNumber2;
        data["taxNumber"] = this.taxNumber;
        data["country"] = this.country;
        data["prefecture"] = this.prefecture;
        data["city"] = this.city;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddress {
    fullName?: string | undefined;
    representativeName?: string | undefined;
    email?: string | undefined;
    phoneNumber1?: string | undefined;
    phoneNumber2?: string | undefined;
    taxNumber?: string | undefined;
    country?: string | undefined;
    prefecture?: string | undefined;
    city?: string | undefined;
    street?: string | undefined;
    postalCode?: string | undefined;
}

export class CompleteSessionResponse implements ICompleteSessionResponse {
    transactionId!: string | undefined;
    orderReference!: string | undefined;
    paidDate!: Date;
    merchant!: string | undefined;
    version!: string | undefined;

    constructor(data?: ICompleteSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.orderReference = _data["orderReference"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.merchant = _data["merchant"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): CompleteSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["orderReference"] = this.orderReference;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["merchant"] = this.merchant;
        data["version"] = this.version;
        return data;
    }
}

export interface ICompleteSessionResponse {
    transactionId: string | undefined;
    orderReference: string | undefined;
    paidDate: Date;
    merchant: string | undefined;
    version: string | undefined;
}

export class CreateSessionRequest implements ICreateSessionRequest {
    invoiceType?: WayOfPayment;

    constructor(data?: ICreateSessionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): CreateSessionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface ICreateSessionRequest {
    invoiceType?: WayOfPayment;
}

export class CreateSessionResponse implements ICreateSessionResponse {
    sessionId!: string | undefined;
    transactionId!: string | undefined;
    merchant!: string | undefined;
    version!: string | undefined;
    orderReference!: string | undefined;

    constructor(data?: ICreateSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
            this.transactionId = _data["transactionId"];
            this.merchant = _data["merchant"];
            this.version = _data["version"];
            this.orderReference = _data["orderReference"];
        }
    }

    static fromJS(data: any): CreateSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        data["transactionId"] = this.transactionId;
        data["merchant"] = this.merchant;
        data["version"] = this.version;
        data["orderReference"] = this.orderReference;
        return data;
    }
}

export interface ICreateSessionResponse {
    sessionId: string | undefined;
    transactionId: string | undefined;
    merchant: string | undefined;
    version: string | undefined;
    orderReference: string | undefined;
}

export class EncryptedData implements IEncryptedData {
    ciphertext?: string | undefined;
    nonce?: string | undefined;
    tag?: string | undefined;

    constructor(data?: IEncryptedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ciphertext = _data["ciphertext"];
            this.nonce = _data["nonce"];
            this.tag = _data["tag"];
        }
    }

    static fromJS(data: any): EncryptedData {
        data = typeof data === 'object' ? data : {};
        let result = new EncryptedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ciphertext"] = this.ciphertext;
        data["nonce"] = this.nonce;
        data["tag"] = this.tag;
        return data;
    }
}

export interface IEncryptedData {
    ciphertext?: string | undefined;
    nonce?: string | undefined;
    tag?: string | undefined;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class InsertOrderItemRequest implements IInsertOrderItemRequest {
    sku!: string | undefined;
    quantity?: number;
    propertyId?: string | undefined;

    constructor(data?: IInsertOrderItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): InsertOrderItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrderItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IInsertOrderItemRequest {
    sku: string | undefined;
    quantity?: number;
    propertyId?: string | undefined;
}

export class InsertOrderRequest implements IInsertOrderRequest {
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    currency?: string | undefined;
    dueDate?: Date | undefined;
    orderItems?: InsertOrderItemRequest[] | undefined;

    constructor(data?: IInsertOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wayOfPayment = _data["wayOfPayment"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceUri = _data["invoiceUri"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? Address.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.currency = _data["currency"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(InsertOrderItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wayOfPayment"] = this.wayOfPayment;
        data["invoiceType"] = this.invoiceType;
        data["invoiceUri"] = this.invoiceUri;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInsertOrderRequest {
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    currency?: string | undefined;
    dueDate?: Date | undefined;
    orderItems?: InsertOrderItemRequest[] | undefined;
}

export class NbgPaymentGatewayRequest implements INbgPaymentGatewayRequest {
    order?: Order | undefined;
    transaction?: Transaction | undefined;
    response?: Response | undefined;
    encryptedData?: EncryptedData | undefined;
    delegate?: string | undefined;
    result?: string | undefined;

    constructor(data?: INbgPaymentGatewayRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : <any>undefined;
            this.transaction = _data["transaction"] ? Transaction.fromJS(_data["transaction"]) : <any>undefined;
            this.response = _data["response"] ? Response.fromJS(_data["response"]) : <any>undefined;
            this.encryptedData = _data["encryptedData"] ? EncryptedData.fromJS(_data["encryptedData"]) : <any>undefined;
            this.delegate = _data["delegate"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): NbgPaymentGatewayRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NbgPaymentGatewayRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["encryptedData"] = this.encryptedData ? this.encryptedData.toJSON() : <any>undefined;
        data["delegate"] = this.delegate;
        data["result"] = this.result;
        return data;
    }
}

export interface INbgPaymentGatewayRequest {
    order?: Order | undefined;
    transaction?: Transaction | undefined;
    response?: Response | undefined;
    encryptedData?: EncryptedData | undefined;
    delegate?: string | undefined;
    result?: string | undefined;
}

export class Order implements IOrder {
    id?: string | undefined;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IOrder {
    id?: string | undefined;
}

export class OrderItemResponse implements IOrderItemResponse {
    id?: string;
    orderId?: number;
    sku!: string | undefined;
    title!: string | undefined;
    productType?: ProductType;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;
    vatRate?: number;
    total?: number;
    quantity?: number;
    propertyId?: string | undefined;

    constructor(data?: IOrderItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderId = _data["orderId"];
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.productType = _data["productType"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.vatRate = _data["vatRate"];
            this.total = _data["total"];
            this.quantity = _data["quantity"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): OrderItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderId"] = this.orderId;
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["productType"] = this.productType;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["vatRate"] = this.vatRate;
        data["total"] = this.total;
        data["quantity"] = this.quantity;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IOrderItemResponse {
    id?: string;
    orderId?: number;
    sku: string | undefined;
    title: string | undefined;
    productType?: ProductType;
    description?: string | undefined;
    unitPrice?: number;
    discount?: number;
    vatRate?: number;
    total?: number;
    quantity?: number;
    propertyId?: string | undefined;
}

export class OrderResponse implements IOrderResponse {
    id?: number;
    number!: string | undefined;
    createdDate?: Date;
    completedDate?: Date | undefined;
    dueDate?: Date | undefined;
    netTotal?: number;
    vatTotal?: number;
    total?: number;
    totalDiscount?: number;
    status?: OrderStatus;
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    sessionId?: string | undefined;
    currency?: string | undefined;
    transaction?: TransactionResponse | undefined;
    orderItems?: OrderItemResponse[] | undefined;

    constructor(data?: IOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.netTotal = _data["netTotal"];
            this.vatTotal = _data["vatTotal"];
            this.total = _data["total"];
            this.totalDiscount = _data["totalDiscount"];
            this.status = _data["status"];
            this.wayOfPayment = _data["wayOfPayment"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceUri = _data["invoiceUri"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? Address.fromJS(_data["shippingAddress"]) : <any>undefined;
            this.sessionId = _data["sessionId"];
            this.currency = _data["currency"];
            this.transaction = _data["transaction"] ? TransactionResponse.fromJS(_data["transaction"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(OrderItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["netTotal"] = this.netTotal;
        data["vatTotal"] = this.vatTotal;
        data["total"] = this.total;
        data["totalDiscount"] = this.totalDiscount;
        data["status"] = this.status;
        data["wayOfPayment"] = this.wayOfPayment;
        data["invoiceType"] = this.invoiceType;
        data["invoiceUri"] = this.invoiceUri;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        data["sessionId"] = this.sessionId;
        data["currency"] = this.currency;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderResponse {
    id?: number;
    number: string | undefined;
    createdDate?: Date;
    completedDate?: Date | undefined;
    dueDate?: Date | undefined;
    netTotal?: number;
    vatTotal?: number;
    total?: number;
    totalDiscount?: number;
    status?: OrderStatus;
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    sessionId?: string | undefined;
    currency?: string | undefined;
    transaction?: TransactionResponse | undefined;
    orderItems?: OrderItemResponse[] | undefined;
}

export class OrderResponseResultSet implements IOrderResponseResultSet {
    count?: number;
    items?: OrderResponse[] | undefined;
    totalSum?: number;

    constructor(data?: IOrderResponseResultSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderResponse.fromJS(item));
            }
            this.totalSum = _data["totalSum"];
        }
    }

    static fromJS(data: any): OrderResponseResultSet {
        data = typeof data === 'object' ? data : {};
        let result = new OrderResponseResultSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalSum"] = this.totalSum;
        return data;
    }
}

export interface IOrderResponseResultSet {
    count?: number;
    items?: OrderResponse[] | undefined;
    totalSum?: number;
}

export enum OrderStatus {
    Pending = "Pending",
    PendingPayment = "PendingPayment",
    Completed = "Completed",
    Invoiced = "Invoiced",
    Rejected = "Rejected",
    Cancelled = "Cancelled",
}

export class OrderStatusResponse implements IOrderStatusResponse {
    orderId?: number;
    status?: OrderStatus;

    constructor(data?: IOrderStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): OrderStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrderStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["status"] = this.status;
        return data;
    }
}

export interface IOrderStatusResponse {
    orderId?: number;
    status?: OrderStatus;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProductResponse implements IProductResponse {
    sku!: string | undefined;
    title!: string | undefined;
    description?: string | undefined;
    unitPrice?: number;
    vatRate?: number;
    type?: ProductType;
    initiatesWorkflows?: string[] | undefined;

    constructor(data?: IProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.vatRate = _data["vatRate"];
            this.type = _data["type"];
            if (Array.isArray(_data["initiatesWorkflows"])) {
                this.initiatesWorkflows = [] as any;
                for (let item of _data["initiatesWorkflows"])
                    this.initiatesWorkflows!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["vatRate"] = this.vatRate;
        data["type"] = this.type;
        if (Array.isArray(this.initiatesWorkflows)) {
            data["initiatesWorkflows"] = [];
            for (let item of this.initiatesWorkflows)
                data["initiatesWorkflows"].push(item);
        }
        return data;
    }
}

export interface IProductResponse {
    sku: string | undefined;
    title: string | undefined;
    description?: string | undefined;
    unitPrice?: number;
    vatRate?: number;
    type?: ProductType;
    initiatesWorkflows?: string[] | undefined;
}

export enum ProductType {
    Unspecified = "Unspecified",
    Service = "Service",
    Bundle = "Bundle",
}

export enum ProofOfPayment {
    Unspecified = "Unspecified",
    Receipt = "Receipt",
    Invoice = "Invoice",
}

export class Response implements IResponse {
    gatewayRecommendation?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayRecommendation = _data["gatewayRecommendation"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayRecommendation"] = this.gatewayRecommendation;
        return data;
    }
}

export interface IResponse {
    gatewayRecommendation?: string | undefined;
}

export class ServiceOrder implements IServiceOrder {
    sku?: string | undefined;
    bought?: boolean | undefined;

    constructor(data?: IServiceOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sku = _data["sku"];
            this.bought = _data["bought"];
        }
    }

    static fromJS(data: any): ServiceOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["bought"] = this.bought;
        return data;
    }
}

export interface IServiceOrder {
    sku?: string | undefined;
    bought?: boolean | undefined;
}

export class ServiceOrderListResponse implements IServiceOrderListResponse {
    services?: ServiceOrder[] | undefined;

    constructor(data?: IServiceOrderListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceOrderListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOrderListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceOrderListResponse {
    services?: ServiceOrder[] | undefined;
}

export class Transaction implements ITransaction {
    id?: string | undefined;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ITransaction {
    id?: string | undefined;
}

export class TransactionResponse implements ITransactionResponse {
    transactionId?: string | undefined;
    errorCode?: number;
    status?: TransactionStatus;
    paidDate?: Date | undefined;
    cardInfo?: string | undefined;

    constructor(data?: ITransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.errorCode = _data["errorCode"];
            this.status = _data["status"];
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : <any>undefined;
            this.cardInfo = _data["cardInfo"];
        }
    }

    static fromJS(data: any): TransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["errorCode"] = this.errorCode;
        data["status"] = this.status;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        data["cardInfo"] = this.cardInfo;
        return data;
    }
}

export interface ITransactionResponse {
    transactionId?: string | undefined;
    errorCode?: number;
    status?: TransactionStatus;
    paidDate?: Date | undefined;
    cardInfo?: string | undefined;
}

export enum TransactionStatus {
    Unspecified = "Unspecified",
    Pending = "Pending",
    Authorized = "Authorized",
    Paid = "Paid",
    Failed = "Failed",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Chargeback = "Chargeback",
    Expired = "Expired",
}

export class UpdateOrderItemRequest implements IUpdateOrderItemRequest {
    id?: string;
    sku!: string | undefined;
    title!: string | undefined;
    description?: string | undefined;
    unitPrice?: number;
    vatRate?: number;
    total?: number;
    quantity?: number;
    propertyId?: string | undefined;

    constructor(data?: IUpdateOrderItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sku = _data["sku"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.vatRate = _data["vatRate"];
            this.total = _data["total"];
            this.quantity = _data["quantity"];
            this.propertyId = _data["propertyId"];
        }
    }

    static fromJS(data: any): UpdateOrderItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sku"] = this.sku;
        data["title"] = this.title;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["vatRate"] = this.vatRate;
        data["total"] = this.total;
        data["quantity"] = this.quantity;
        data["propertyId"] = this.propertyId;
        return data;
    }
}

export interface IUpdateOrderItemRequest {
    id?: string;
    sku: string | undefined;
    title: string | undefined;
    description?: string | undefined;
    unitPrice?: number;
    vatRate?: number;
    total?: number;
    quantity?: number;
    propertyId?: string | undefined;
}

export class UpdateOrderRequest implements IUpdateOrderRequest {
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    orderItems?: UpdateOrderItemRequest[] | undefined;

    constructor(data?: IUpdateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wayOfPayment = _data["wayOfPayment"];
            this.invoiceType = _data["invoiceType"];
            this.invoiceUri = _data["invoiceUri"];
            this.billingAddress = _data["billingAddress"] ? Address.fromJS(_data["billingAddress"]) : <any>undefined;
            this.shippingAddress = _data["shippingAddress"] ? Address.fromJS(_data["shippingAddress"]) : <any>undefined;
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [] as any;
                for (let item of _data["orderItems"])
                    this.orderItems!.push(UpdateOrderItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wayOfPayment"] = this.wayOfPayment;
        data["invoiceType"] = this.invoiceType;
        data["invoiceUri"] = this.invoiceUri;
        data["billingAddress"] = this.billingAddress ? this.billingAddress.toJSON() : <any>undefined;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            for (let item of this.orderItems)
                data["orderItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateOrderRequest {
    wayOfPayment?: WayOfPayment;
    invoiceType?: ProofOfPayment;
    invoiceUri?: string | undefined;
    billingAddress?: Address | undefined;
    shippingAddress?: Address | undefined;
    orderItems?: UpdateOrderItemRequest[] | undefined;
}

export enum WayOfPayment {
    Unspecified = "Unspecified",
    BankDeposit = "BankDeposit",
    CreditCard = "CreditCard",
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}